import Plugin from 'src/plugin-system/plugin.class';
import Swiper from 'swiper/bundle';

export default class ProductsSliderPlugin extends Plugin {
    init() {

        const swiper = new Swiper('.products-slider-widget', {
            slidesPerView: 3,
            spaceBetween: 10,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            breakpoints: {
                568: {
                  slidesPerView: 4,
                  spaceBetween: 30
                },
                // 667: {
                //     slidesPerView: 3,
                //     spaceBetween: 30
                // },
                // 768: {
                //     slidesPerView: 3,
                //     spaceBetween: 30
                // },
                992: {
                    slidesPerView: 5,
                    spaceBetween: 30
                },
                // 1100: {
                //     slidesPerView: 3,
                //     spaceBetween: 30
                // },
                // 1200: {
                //     slidesPerView: 3,
                //     spaceBetween: 30
                // },
                // 1500: {
                //     slidesPerView: 3,
                //     spaceBetween: 30
                // }
            },
            loop: false,
            centeredSlides: false
        });

        document.addEventListener('Viewport/hasChanged', () => {
            swiper.update();
        });

    }

}